export const gradientBackgroundColor = "linear-gradient(241deg, #003027, #d9e1e7)"
export const greenColor = "#003027"
export const whiteColor = "#d9e1e7"